/*
 * @Author: Teemo Ding
 * @Date: 2021-05-31 09:12:38
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-01 14:01:10
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelCollection/Components/CopyModal/index.tsx
 */
import { message } from 'antd';
import _ from 'lodash';
import React, { useState } from 'react';

import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import CheckModal from '@/src/components/CheckItem/CheckItem';
import Row from '@/src/components/Layouts/Row/Row';
import { copyProducts } from '@/src/request/salesChannel/collection';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

interface IProps {
  setShowModal: (value: boolean) => void;
  collectionList;
  salesChannelProductUuids;
}

const CopyModal = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { setShowModal, collectionList, salesChannelProductUuids } = props;

  const [copyCheck, setCopyCheck] = useState<number[]>([]);
  const [checkErr, setCheckErr] = React.useState(false);
  const handleClickCancel = () => {
    setShowModal(false);
  };
  const collectionCheckboxList = collectionList.map((item) => ({
    key: item.uuid,
    name: item.collectionName,
  }));

  const handleOnSubmit = () => {
    const data = {
      salesChannelCollectionUuids: copyCheck,
      salesChannelProductUuids: salesChannelProductUuids,
    };
    copyProducts(data)
      .then((data) => {
        message.success(
          replaceI18nVariables(
            getI18n('productCollection.index.copyProductsSuccess'),
            copyCheck.length,
          ),
        );
        setShowModal(false);
      })
      .catch((error) => {
        console.error(`handleOnSubmit error ${error}`);
      });
  };

  const handleSetCheck = (value) => {
    const copyCheckCopy = _.cloneDeep(copyCheck);
    if (copyCheck.includes(value)) {
      const index = copyCheckCopy.indexOf(value);
      copyCheckCopy.splice(index, 1);
      setCopyCheck(copyCheckCopy);
    } else {
      copyCheckCopy.push(value);
      setCopyCheck(copyCheckCopy);
    }
  };

  return (
    <div>
      <Row
        elements={[
          {
            child: (
              <CheckModal
                title={getI18n('productCollection.index.selectdetailstocopy')}
                checkList={collectionCheckboxList}
                setCheck={(value) => handleSetCheck(value)}
                check={copyCheck}
                setErr={setCheckErr}
                err={checkErr}
              />
            ),
          },
        ]}
      />
      <ModalFooter
        onCancel={handleClickCancel}
        okText={getI18n('general.copy')}
        hideOkButton={copyCheck.length === 0}
        onOk={handleOnSubmit}
      />
    </div>
  );
};
export default CopyModal;
